
import { GameStatistic } from '@/lib/dtos/GameStatistic'
import { Component, Vue, Watch } from 'vue-property-decorator'
import BacButton from '../BacButton.vue'

@Component({
  components: {
    BacButton
  }
})
export default class ChallengeStatiBacButtonstics extends Vue {
  games: GameStatistic[] = [];

  mounted () {
    this.loadGames()
  }

  @Watch('$store.state.PageURLRallyRound.rallyRound')
  async loadGames () {
    if (!this.$store.state.PageURLRallyRound.rallyRound.id) {
      return
    }
    this.games = await GameStatistic.getForRallyRound(
      this.$store.state.PageURLRallyRound.rallyRound.id
    )
  }

  @Watch('games')
  onGamesChange () {
    this.games.forEach((game: GameStatistic) => {
      game.getStatisticForRallyRound(this.$store.state.PageURLRallyRound.rallyRound.id)
    })
  }
}
